export default "__VITE_ASSET__DrG3IEbU__"